import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { environment } from "src/environments/environment";

@Component({
  selector: 'app-member-banner',
  templateUrl: './member-banner.component.html',
  styleUrls: ['./member-banner.component.scss']
})
export class MemberBannerComponent implements OnInit {

  @Input() adminMode: boolean = false;
  @ViewChild("AssignOption") AssignOptionModal: ElementRef;
  public editMode: boolean;
  public commonModal: any;
  public allAds: Array<any> = [];
  public subRegionList: Array<any> = [];
  public selectedAds: any;
  public imageBase64: string | ArrayBuffer;
  public imgUrl = environment.ImageUrl;
  public form: FormGroup = new FormGroup({
    image: new FormControl(null, [Validators.required]),
    url: new FormControl("",),
    subregion: new FormControl(""),
  });

  item: any = {
    0: {
      items: 2
    },
  }
  constructor(private toastr: ToastrService, private modalService: NgbModal, private auth: AuthServiceService, public commonService: CommonService) { }

  ngOnInit(): void {
    this._getAdsList();
  }

  public openProductCharForAddEdit(model, selected: any = null) {
    if (selected) {
      this.editMode = true;
      this.selectedAds = selected;
      this.form.patchValue({
        image: selected?.image,
        description: selected?.description,
        price: selected?.price,
        url: selected?.url,
        category: selected?.category,
        subRegion: selected?.subRegion,
      });
    }
    this.commonModal = this.modalService.open(model, {
      size: "xs",
      backdrop: "static",
      windowClass: "suggestion",
    });
  }




  public openModal(selectedArticle) {


    let selectedId = selectedArticle.subRegion ? selectedArticle.subRegion.split('|') : [];

    this.subRegionList = structuredClone(this.commonService.subRegionLists.map((j) => {
      let output = JSON.parse(JSON.stringify(j));
      output['checked'] = selectedId.includes(j.subRegionId.toString());
      return output;
    }));

    this.selectedAds = selectedArticle;
    this.commonModal = this.modalService.open(this.AssignOptionModal, { size: "sm", ariaLabelledBy: "modal-basic-title", backdrop: "static" });
  }

  assignArticles() {
    if (this.selectedAds) {
      let subRegionStr = this.subRegionList
        .filter((i) => i.checked)
        .map((i) => i.subRegionId)
        .join("|");

      let formData = new FormData();
      formData.append("url", this.selectedAds.url);
      formData.append("id", this.selectedAds?.id);
      formData.append("subRegion", subRegionStr ? subRegionStr : 'default');

      this.auth.addMemberPageBanner(formData).subscribe((resp: ApiResponse) => {
        this.toastr.success(resp.message);
        this.commonModal.close();
        this._getAdsList();
        this.selectedAds = null;
      });
    } else {
      this.toastr.error("InValid Id!");
    }
  }

  private _getAdsList() {
    this.auth.getAllMemberPageBanner().subscribe((resp: ApiResponse) => {
      let output = [];
      for (let i of resp.body) {
        output.push({ ...i, ...{ categoryList: (i.category && i.category.includes('|') ? i.category.split('|') : [i.category]), subRegionList: (i.subRegion && i.subRegion.includes('|') ? i.subRegion.split('|') : [i.subRegion]) } });
      }
      this.allAds = output;

    });
  }

  public saveAds(): void {
    if (this.form.valid) {
      let formData = new FormData();
      typeof this.form.get("image").value == "string" ? "" : formData.append("image", this.form.get("image").value);
      formData.append("url", this.form.get("url").value);
      formData.append("subRegion", 'default');
      if (this.selectedAds) {
        formData.append("id", this.selectedAds?.id);
      }
      this.auth.addMemberPageBanner(formData).subscribe((resp: ApiResponse) => {
        this.toastr.success(resp.message);
        this.modalDismissAll();
        this._getAdsList();
        this.selectedAds = null;
      });
    } else {
      this.toastr.error("Form is Invalid fill ALL ");
    }
  }

  public modalDismissAll() {
    this.modalService.dismissAll();
    this.selectedAds = null;
  }

  public saveProductCharSelectedImage(event) {
    this.selectedAds ? (this.selectedAds.image = null) : "";
    let file = event.target.files[0];
    let fileReader = new FileReader();
    fileReader.onload = () => {
      this.imageBase64 = fileReader.result;
      this.form.get("image").setValue(file);
    };
    fileReader.readAsDataURL(file);
  }

  public deleteAds(id) {
    this.auth.deleteMemberPageBanner(id).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this._getAdsList();
    });
  }

}
